export default __webpack_public_path__ + "static/media/youse-map.9a89c3f0.png";